var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStockMaterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 15C2.3375 15 1.98438 14.8531 1.69063 14.5594C1.39688 14.2656 1.25 13.9125 1.25 13.5V5.04375C1.025 4.90625 0.84375 4.72813 0.70625 4.50938C0.56875 4.29063 0.5 4.0375 0.5 3.75V1.5C0.5 1.0875 0.646875 0.734375 0.940625 0.440625C1.23438 0.146875 1.5875 0 2 0H14C14.4125 0 14.7656 0.146875 15.0594 0.440625C15.3531 0.734375 15.5 1.0875 15.5 1.5V3.75C15.5 4.0375 15.4313 4.29063 15.2938 4.50938C15.1563 4.72813 14.975 4.90625 14.75 5.04375V13.5C14.75 13.9125 14.6031 14.2656 14.3094 14.5594C14.0156 14.8531 13.6625 15 13.25 15H2.75ZM2.75 5.25V13.5H13.25V5.25H2.75ZM2 3.75H14V1.5H2V3.75ZM5.75 9H10.25V7.5H5.75V9Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockMaterIcon);
export default __webpack_public_path__ + "static/media/stock-mater-icon.381afd343d74361fca678f01a686230d.svg";
export { ForwardRef as ReactComponent };